import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import CheckBox from 'modules/core/components/Inputs/CheckBox'

interface Props {
  field: Field
  disabled?: boolean
  onClick: React.MouseEventHandler<HTMLInputElement>
}

const FancyCheckbox = ({ disabled = false, field, onClick }: Props) => {
  const onDefaultClick = () => {
    field.mapAndSet(!field.value)
  }

  return <CheckBox disabled={disabled} checked={field.value} onClick={onClick ?? onDefaultClick} />
}

export default observer(FancyCheckbox)
